<main>
  <div>
    <div class="eventType-head flex-wrap gap-2">
      <div
        class="d-flex align-items-center gap-3"
        style="cursor: pointer"
        (click)="goBack()"
      >
        <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
        <div class="header-text eventType-text">Event types management</div>
      </div>
      <div class="buttonContainer flex-wrap">
        <!-- <div> -->
        <div class="search-container">
          <div class="search-icon">
            <img
              src="assets/icons/side-bar/search-normal.svg"
              alt="search"
              style="width: 18px; height: 18px"
            />
          </div>
          <input
            type="text"
            placeholder="Search here..."
            class="search-input"
            [(ngModel)]="search"
            (input)="updateSearch(search)"
            (keyup.enter)="applyFilter()"
            autocomplete="off"
          />
        </div>
        <!-- </div> -->

        <div class="status-dropdown-container">
          <div
            class="status-display"
            [ngClass]="getStatusClass(selectedStatus)"
            (click)="toggleStatusDropdown($event)"
          >
            {{ selectedStatus ? selectedStatus : "All" }}
            <img
              src="assets/images/Buttons/arrow.svg"
              class="dropdown-arrow"
              [class.rotated]="!showStatusDropdown"
            />
          </div>

          <div
            class="status-dropdown-menu"
            [class.show]="showStatusDropdown"
            (click)="$event.stopPropagation()"
          >
            <div
              *ngFor="let status of statusOptions"
              class="status-option"
              [class.active]="selectedStatus === status.value"
              (click)="updateEventStatus(status.value)"
            >
              {{ status.label }}
            </div>
          </div>

          <div
            class="status-backdrop"
            *ngIf="showStatusDropdown"
            (click)="closeStatusDropdown()"
          ></div>
        </div>

        <button
          class="generate-btn"
          *ngIf="userRoles.genarateReport"
          (click)="navigateReports()"
        >
          Generate report<img
            class="action-button"
            src="assets/images/arrow-up-right.svg"
            alt="Edit"
          />
        </button>

        <app-button
          label="Add new event type"
          *ngIf="userRoles.addNew"
          [minWidth]="'14rem'"
          (clicked)="openAddDialog()"
        >
        </app-button>
      </div>
    </div>

    <!-- <div class="d-grid gap-3"> -->
    <!-- <div class="table-card">
        <div>
            <div class="chart-text">
                Overall event participation trends
            </div>
        </div>
        <app-event-type-chart></app-event-type-chart>
    </div> -->
    <div class="table-card">
      <!-- <div class="d-flex justify-content-end pb-3 filter-dropdown-container" #filterDropdownContainer>
            <button class="filter-button" (click)="toggleFilterMenu($event)">
                <img src="assets/images/filter-edit.svg" alt="search" class="filter-icon" />
            </button>
            <app-filter-menu #filterMenu class="filter-dropdown-menu" [class.show]="showFilterMenu"
            [filters]="currentFilters" (filtersApplied)="onFiltersApplied($event)"
            (filtersCleared)="onFiltersCleared()" (menuClosed)="closeFilterMenu()">
        </app-filter-menu>
        
        <div class="filter-backdrop" [class.show]="showFilterMenu" (click)="closeFilterMenu()"></div>
    </div> -->
      <app-table
        [columns]="columns"
        [data]="data"
        [actionTemplate]="actionButtonsTemplate"
        (statusClick)="onStatusClick($event)"
        [loading]="loading"
      >
      </app-table>
    </div>
    <!-- </div> -->
  </div>
</main>

<ng-template #actionButtons let-row *ngIf="userRoles.listItem.edit">
  <div style="display: flex; gap: 0.8rem; justify-content: center">
    <img
      class="action-button"
      *ngIf="userRoles.listItem.edit"
      (click)="onEdit(row)"
      src="assets/images/Buttons/edit-button.svg"
      alt="Edit"
    />
    <div style="height: 1.5rem; width: 1.5rem">
      <img
        [style.display]="
          row?.eventTypeName === 'Teacher Work Experience' ||
          row?.eventTypeName === 'Student External Event'
            ? 'none'
            : 'inline-block'
        "
        class="action-button"
        (click)="onDelete(row)"
        src="assets/images/Buttons/delete-button.svg"
        alt="Delete"
      />
    </div>
  </div>
</ng-template>

<ng-template #addEventTypeContent>
  <add-event-type
    [initialData]="editingEventType"
    (formSubmitted)="onEventTypeFormSubmit($event)"
  >
  </add-event-type>
</ng-template>
